/**
 * Parse various date formats to ISO timestamp
 * Supports:
 * - ISO 8601 format (2024-12-15T10:00:00Z)
 * - Date only (2024-12-15)
 * - MM/DD/YYYY format (12/15/2024)
 */
export const parseTimestamp = (value: string): string | null => {
  if (!value) return null;

  // Try ISO 8601 format
  const isoDate = new Date(value);
  if (!isNaN(isoDate.getTime())) {
    return isoDate.toISOString();
  }

  // Try MM/DD/YYYY format
  const dateMatch = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (dateMatch) {
    const month = dateMatch[1];
    const day = dateMatch[2];
    const year = dateMatch[3];
    if (month && day && year) {
      const date = new Date(`${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`);
      if (!isNaN(date.getTime())) {
        return date.toISOString();
      }
    }
  }

  return null;
};
